(() => {
  const instances = new WeakMap();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope = document) {
    scope.querySelectorAll('[data-sawas-journey]').forEach(root => {
      if (instances.has(root)) return;
      const abort = new AbortController();
      const on = (target, event, callback) => target.addEventListener(event, callback, { signal: abort.signal });
      const figures = [...root.querySelectorAll('[data-figure]')];
      const track = root.querySelector('.journey-track');
      const stage = root.querySelector('.journey-stage');
      const link = root.querySelector('[data-journey-link]');
      const pause = root.querySelector('[data-journey-pause]');
      const pauseText = pause.getAttribute('aria-label');
      const playText = pause.dataset.play;
      let index = 0, timer, visible = true, paused = motion.matches || Boolean(window.Shopify?.designMode);
      function select(next) {
        index = next;
        track.style.setProperty('--step', index);
        stage.scrollLeft = 0;
        figures.forEach((figure, i) => {
          const active = i === index;
          figure.classList.toggle('active', active);
          figure.setAttribute('aria-pressed', String(active));
          figure.querySelector('.figure-label').hidden = !active;
        });
        root.querySelector('[data-journey-link-label]').textContent = figures[index].dataset.label;
        const url = figures[index].dataset.url;
        if (url) { link.setAttribute('href', url); link.removeAttribute('aria-disabled'); }
        else { link.removeAttribute('href'); link.setAttribute('aria-disabled', 'true'); }
      }
      function schedule() {
        clearInterval(timer);
        pause.textContent = paused ? '▷' : 'Ⅱ';
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? playText : pauseText);
        if (!paused && visible && !document.hidden)
          timer = setInterval(() => select((index + 1) % figures.length), Number(root.dataset.interval) || 3000);
      }
      figures.forEach((figure, i) => {
        const activate = () => {select(i); paused = true; schedule();};
        on(figure, 'pointerenter', event => {if (event.pointerType === 'mouse') activate();});
        on(figure, 'focus', activate);
        on(figure, 'click', () => {activate(); if (figure.dataset.url && !window.Shopify?.designMode) location.href = figure.dataset.url;});
      });
      on(pause, 'click', () => {paused = !paused; schedule();});
      ['pointerenter', 'focus'].forEach(event => on(link, event, () => {paused = true; schedule();}));
      on(document, 'visibilitychange', schedule);
      on(motion, 'change', event => {if (event.matches) {paused = true; schedule();}});
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting; schedule();}, {threshold: .15});
      observer.observe(root);
      select(0); schedule();
      instances.set(root, () => {clearInterval(timer); observer.disconnect(); abort.abort();});
    });
    scope.querySelectorAll('.reveal').forEach(element => {
      if (instances.has(element)) return;
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {entry.target.classList.add('visible'); observer.unobserve(entry.target);}
      }), {threshold: .08});
      observer.observe(element);
      instances.set(element, () => observer.disconnect());
    });
    scope.querySelectorAll('[data-sawas-header]').forEach(root => {
      if (instances.has(root)) return;
      const abort = new AbortController();
      const menu = root.querySelector('.menu-dialog');
      const trigger = root.querySelector('[data-menu-open]');
      const demo = root.querySelector('[data-demo-dialog]');
      let lastFocus;
      root.addEventListener('click', event => {
        if (event.target.closest('[data-menu-open]')) {lastFocus = trigger; menu.showModal(); trigger.setAttribute('aria-expanded', 'true');}
        if (event.target.closest('[data-demo-open]')) {lastFocus = event.target.closest('button'); demo.showModal();}
        if (event.target.closest('[data-dialog-close]')) event.target.closest('dialog')?.close();
      }, {signal: abort.signal});
      root.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();}, {signal: abort.signal});
        dialog.addEventListener('close', () => {trigger.setAttribute('aria-expanded', 'false'); lastFocus?.focus();}, {signal: abort.signal});
      });
      instances.set(root, () => {root.querySelectorAll('dialog[open]').forEach(d => d.close()); abort.abort();});
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-sawas-journey], [data-sawas-header], .reveal').forEach(root => {
      instances.get(root)?.(); instances.delete(root);
    });
  });
  document.addEventListener('shopify:block:select', event => {
    event.target.classList.add('visible');
    event.target.scrollIntoView({block: 'nearest', inline: 'nearest'});
  });
  function updateScroll() {
    document.querySelector('#header')?.classList.toggle('scrolled', scrollY > 45);
    const progress = document.querySelector('#page-progress');
    const max = document.documentElement.scrollHeight - innerHeight;
    if (progress) progress.style.transform = `scaleX(${max > 0 ? Math.min(1, scrollY / max) : 0})`;
  }
  addEventListener('scroll', updateScroll, {passive: true});
  updateScroll();
})();

// Product details use Shopify catalogue data; enquiries do not place an order.
document.querySelectorAll('[data-product-enquiry]').forEach(button => button.addEventListener('click', () => {
  const phone=button.dataset.phone.replace(/\D/g,'');
  if(phone.length<8 || phone.length>15)return;
  const select=document.querySelector('#product-variant');
  const variant=select?.selectedOptions[0]?.textContent || '';
  const message=`SAWAS — Ürün hakkında bilgi almak istiyorum.\n${button.dataset.title}\n${variant}\n${button.dataset.url}`;
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`,'_blank','noopener,noreferrer');
}));
document.querySelector('#product-variant')?.addEventListener('change',event=>{const price=document.querySelector('.shopify-product .price');if(price)price.textContent=event.target.selectedOptions[0].dataset.price;});
